"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isModifierPressed = exports.preventDefaultHandler = exports.stopPropagationHandler = exports.isLeftClick = void 0;
var LEFT_MOUSE_BUTTON = 0;

var isLeftClick = function isLeftClick(mouseEvent) {
  var button = mouseEvent.button,
      altKey = mouseEvent.altKey,
      ctrlKey = mouseEvent.ctrlKey,
      shiftKey = mouseEvent.shiftKey,
      metaKey = mouseEvent.metaKey;
  return button === LEFT_MOUSE_BUTTON && !(altKey || ctrlKey || shiftKey || metaKey);
};

exports.isLeftClick = isLeftClick;

var stopPropagationHandler = function stopPropagationHandler(evt) {
  if (evt) evt.stopPropagation();
};

exports.stopPropagationHandler = stopPropagationHandler;

var preventDefaultHandler = function preventDefaultHandler(evt) {
  if (evt) evt.preventDefault();
};
/**
 * @param {InputEvent} evt
 * @returns {boolean} `true` if any modifier (alt, ctrl, meta, or shift) is pressed
 */


exports.preventDefaultHandler = preventDefaultHandler;

var isModifierPressed = function isModifierPressed(evt) {
  return evt.altKey || evt.ctrlKey || evt.metaKey || evt.shiftKey;
};

exports.isModifierPressed = isModifierPressed;